'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

const PopupWidget = dynamic(
  () => import('react-calendly').then((mod) => mod.PopupWidget),
  { ssr: false }
);

/** Floating "Chat with Ali" Calendly popup, rendered into <body>. */
export function CalendlyPopup() {
  const [rootElement, setRootElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setRootElement(document.body);
  }, []);

  if (!rootElement) return null;

  return (
    <PopupWidget
      url="https://calendly.com/devmtnali/30min"
      rootElement={rootElement}
      text="☕ Chat with Ali"
      color="#8E32E9"
    />
  );
}
